var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "佣金明细",
            visible: _vm.visible,
            "append-to-body": true,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.cancel,
          },
        },
        [
          _c(
            "div",
            { staticClass: "search-contain" },
            [
              _c(
                "el-form",
                {
                  ref: "query",
                  attrs: { model: _vm.query, inline: true, size: "mini" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话/订单号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入电话/订单号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.query.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "keyword", $$v)
                          },
                          expression: "query.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "status", $$v)
                            },
                            expression: "query.status",
                          },
                        },
                        _vm._l(_vm.statusList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "下单时间", prop: "daterange" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.daterange,
                          callback: function ($$v) {
                            _vm.daterange = $$v
                          },
                          expression: "daterange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "首单/复购订单" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.query.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "type", $$v)
                            },
                            expression: "query.type",
                          },
                        },
                        _vm._l(_vm.orderStatusList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.searchChange },
                        },
                        [_vm._v("\n            筛选\n          ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.searchReset },
                        },
                        [_vm._v("\n            清空\n          ")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading.fullscreen.lock",
                              value: _vm.exportLoading,
                              expression: "exportLoading",
                              modifiers: { fullscreen: true, lock: true },
                            },
                          ],
                          staticClass: "add",
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: { click: _vm.exportClick },
                        },
                        [_vm._v("\n            导出\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yd-table",
            {
              attrs: {
                loading: _vm.loading,
                data: _vm.records,
                border: "",
                size: "mini",
                pagination: _vm.pagination,
              },
              on: { onChange: _vm.onTableChange },
            },
            [
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "orderNo", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c(
                              "el-badge",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { value: "首单" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "padding-right": "8px" } },
                                  [_vm._v(_vm._s(scope.row.orderNo))]
                                ),
                              ]
                            )
                          : _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.orderNo) +
                                  "\n          "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "statusName",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c("span", [_vm._v("待出行")])
                          : _vm._e(),
                        scope.row.status === 2
                          ? _c("span", [_vm._v("待付款")])
                          : _vm._e(),
                        scope.row.status === 4
                          ? _c("span", [_vm._v("已取消")])
                          : _vm._e(),
                        scope.row.status === 6
                          ? _c("span", [_vm._v("全部退票")])
                          : _vm._e(),
                        scope.row.status === 7
                          ? _c("span", [_vm._v("已完成")])
                          : _vm._e(),
                        scope.row.status === 8
                          ? _c("span", [_vm._v("行程中")])
                          : _vm._e(),
                        scope.row.status === 9
                          ? _c("span", [_vm._v("已改签")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "下单用户",
                  prop: "phone",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "下单时间",
                  prop: "createTime",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "完单时间/退款时间",
                  prop: "finishTime",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单金额（元）",
                  prop: "amount",
                  align: "center",
                  width: "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.amount / 100) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "佣金金额（元）",
                  prop: "commission",
                  align: "center",
                  width: "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0 || scope.row.status === 8
                          ? _c("span", [_vm._v("待返佣")])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.commission / 100)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }